module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    staticStyle: {
      "height": "5em",
      "width": "85%",
      "background": "#FCFDFD",
      "position": "fixed",
      "top": "0",
      "right": "5px",
      "z-index": "8000"
    }
  }, [_c('div', {
    staticClass: "card card-header-inner",
    staticStyle: {
      "padding-left": "18vw",
      "margin-top": "3px",
      "padding": "0.82em 1em",
      "background": "#ffffff",
      "border-top-right-radius": "18px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "80%"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [(_vm.loggedIn) ? _c('p', [_vm._v("Welcome, " + _vm._s(_vm.user.user_name) + "\n                    "), (_vm.set_app_text_01) ? _c('span', [_vm._v(",\n                        "), (_vm.site_user_type == 2) ? _c('a', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "13px"
    },
    attrs: {
      "href": "/dashboard"
    }
  }, [_vm._v("Manage Store | ")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "13px"
    },
    attrs: {
      "href": "/search"
    }
  }, [_vm._v("Place your Order")])]) : _vm._e()]) : _c('p', [_vm._v("\n                    Welcome. "), _vm._m(0)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "13px"
    },
    attrs: {
      "href": "/search"
    }
  }, [_vm._v("Place your Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('input', {
    staticClass: "form-control",
    staticStyle: {
      "border": "none",
      "border-bottom": "#000000 solid 1px",
      "border-top": "solid #ffffff 0px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right",
      "width": "20%",
      "text-align": "left",
      "padding-left": "1em",
      "padding-top": "8px"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fas fa-map-marker",
    staticStyle: {
      "color": "#ff0000"
    }
  }), _vm._v(" Location")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-486e9a7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/DesktopViews/Header.vue
// module id = 575
// module chunks = 0